// extracted by mini-css-extract-plugin
export default {"switch_container":"qrlogin-switcher_switch_container__s03uN","divider":"qrlogin-switcher_divider__bmoX5","switch_btn":"qrlogin-switcher_switch_btn__fI0G4"};